import { useAuth } from '@/domains/auth/authProvider';

import { faviconForPerspective } from './perspectiveFavicon';

/**
 * Favicon path for the logged-in user's active perspective.
 * Falls back to the default favicon when there is no user, no active
 * perspective, or an unknown perspective name.
 */
export function usePerspectiveFavicon(): string {
  const { user } = useAuth();
  return faviconForPerspective(user?.activePerspective?.name);
}
